module.exports = __webpack_public_path__ + "static/img/shangchuanchangjingtu.039ebb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/shangchuanchangjingtu.png
// module id = FN1E
// module chunks = 24